export default  {
  bindings: {
    availability: '<',
    categories: '<',
    events: '<',
    stock: '<'
  },
  controller: 'stockFormController',
  template: require('../views/stock.form.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/availability/components/stock.form.component.js